import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Portrait({ reduce }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [reduce ? 0 : 50, reduce ? 0 : -50]);

    return (
        <section
            ref={ref}
            data-testid="portrait-section"
            className="relative z-[1] flex flex-col items-center px-6 py-24 text-center sm:py-28"
        >
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            >
                <p className="eyebrow-label mb-4">The Guest of Honour</p>
                <h2 className="font-display text-3xl font-semibold sm:text-4xl">
                    The woman <span className="gold-text italic">of the hour</span>
                </h2>
            </motion.div>

            <motion.div
                className="relative mt-12"
                initial={{ opacity: 0, scale: 0.94, y: 50 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            >
                <div
                    className="absolute left-1/2 top-1/2 h-[115%] w-[120%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#6B3882] opacity-30 blur-[90px]"
                    aria-hidden="true"
                />
                <div
                    className="absolute -inset-3 rounded-t-full rounded-b-[2rem] border border-[#F3D085]/35"
                    aria-hidden="true"
                />
                <div className="relative w-64 overflow-hidden rounded-t-full rounded-b-3xl border-2 border-[#F3D085]/70 shadow-[0_35px_90px_-20px_rgba(0,0,0,0.85)] sm:w-80">
                    <motion.img
                        src="/images/mary.webp"
                        alt="Mary Manzur smiling in a field of lavender"
                        className="h-auto w-full object-cover"
                        style={{ y }}
                        data-testid="mary-portrait"
                    />
                    <div
                        className="pointer-events-none absolute inset-0"
                        style={{ background: "linear-gradient(180deg, rgba(11,7,22,0) 55%, rgba(11,7,22,0.55) 100%)" }}
                        aria-hidden="true"
                    />
                </div>
                <p className="mt-6 font-display text-xl font-light italic text-[#C4B5FD]">
                    Mary Manzur — sacred guide, dreamer, and today's reigning legend
                </p>
            </motion.div>
        </section>
    );
}
